import { render, staticRenderFns } from "./PlanejamentoAcaoList.vue?vue&type=template&id=22dd9342&"
import script from "./PlanejamentoAcaoList.vue?vue&type=script&lang=js&"
export * from "./PlanejamentoAcaoList.vue?vue&type=script&lang=js&"
import style0 from "./PlanejamentoAcaoList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports